// extracted by mini-css-extract-plugin
export default {"fileCard":"Quotation_fileCard__mneOl"};